module.exports = __webpack_public_path__ + "static/media/congratulations-image.f67faa04.svg";